import * as liveServices from '@/services/liveServices';

export default {
  namespaced: true,
  state: {
    initialized: false,
    recentLives: [],
    upComingLives: [], // ログイン中のユーザーのupComingLiveしか入っていないことに注意
    upComingAllLives: [], //TODO: これをupComingLivesにして、userごとのFilterはgettersで行うべき（チューニングとかは未配慮）
    endedLives: [],
    upComingLive: {},
    recentLive: {},
    commentRefObj: {},
    liveComments: [],
    gifts: []
  },
  mutations: {
    updateUpComingLive(state, upComingLive) {
      state.upComingLive = upComingLive;
    },
    updateUpComingAllLives(state, upComingAllLives) {
      state.upComingAllLives = upComingAllLives;
    },
    updateUpComingLives(state, upComingLives) {
      state.upComingLives = upComingLives;
    },
    updateRecentLive(state, recentLive) {
      state.recentLive = recentLive;
    },
    updateRecentLives(state, recentLives) {
      state.recentLives = recentLives;
    },
    updateGifts(state, gifts) {
      state.gifts = gifts;
    }
  },
  actions: {
    async loadUpComingAllLives({ commit }) {
      const upComingLives = await liveServices.getAllUpComingLives();
      commit('updateUpComingAllLives', upComingLives);
    },
    async loadUpComingLivesByUserId({ commit }, payload) {
      const upComingLives = await liveServices.getUpcomingLivesByUserId(
        payload.userId,
        payload.limit
      );
      commit('updateUpComingLives', upComingLives);
    },
    async loadUpComingLive({ commit }, liveId) {
      const upComingLive = await liveServices.getUpComingLiveByLiveId(liveId);
      commit('updateUpComingLive', upComingLive);
    },
    async loadRecentLive({ commit }, liveId) {
      const recentLive = await liveServices.getRecentLiveByLiveId(liveId);
      commit('updateRecentLive', recentLive);
    },
    async loadRecentLives({ commit }) {
      const recentLives = await liveServices.getAllRecentLives();
      commit('updateRecentLives', recentLives);
    },
    async loadGifts({ commit }) {
      const gifts = await liveServices.getGifts();
      commit('updateGifts', gifts);
    }
  },
  getters: {
    playbackUrl(state) {
      return state.recentLive.playbackUrl;
    },
    performerId(state) {
      return state.recentLive.userId;
    },
    upComingLives(state) {
      return state.upComingLives;
    },
    gifts(state) {
      return state.gifts;
    }
  }
};
